import type { Column } from 'slickgrid';
import type { DeviceTableDeviceData } from '@ebiz/aditools-databook';

export default {
  linkFormatter: function (
    _row: number,
    _cell: number,
    value: { url: string; name: string },
    _columnDef: Column<DeviceTableDeviceData>,
    dataContext: DeviceTableDeviceData,
  ): string {
    return [
      '<a target="_blank"',
      'class="recommended-part-item"',
      'rel="noopener noreferrer"',
      'data-action="part"',
      'data-partid="',
      dataContext['id'],
      '"',
      ' href="',
      value.url,
      '">',
      value.name,
      '</a>',
    ].join('');
  },
};
